// =============================================================
// highlevelOpportunitiesService
// Service layer for HighLevel Opportunities / Pipelines API.
// Live mode (future): https://services.leadconnectorhq.com/opportunities/
// v1: mock JSON, stable interface for later live swap.
// =============================================================

import { LEADS, STAGES } from "../data/mockData";

const LIVE_API_ENABLED = false;
const simulateLatency = (data, ms = 120) => new Promise((res) => setTimeout(() => res(data), ms));

export const highlevelOpportunitiesService = {
  isLive: () => LIVE_API_ENABLED,

  /** Returns the pipeline definition (stages, ordered) */
  async getPipeline() {
    return simulateLatency({ pipeline_id: "parent-conversion", name: "Parent Conversion Pipeline", stages: STAGES });
  },

  /** Returns opportunities grouped by stage id */
  async getBoard(filters = {}) {
    let rows = [...LEADS];
    if (filters.branchId) rows = rows.filter((l) => l.branch_id === filters.branchId);
    if (filters.programmeId) rows = rows.filter((l) => l.programme_id === filters.programmeId);
    const board = {};
    STAGES.forEach((s) => { board[s.id] = rows.filter((l) => l.stage === s.id); });
    return simulateLatency(board);
  },

  /** Move an opportunity to a new stage (mock: mutates in-memory) */
  async moveStage(contactId, newStageId) {
    const lead = LEADS.find((l) => l.contact_id === contactId);
    const stage = STAGES.find((s) => s.id === newStageId);
    if (lead && stage) {
      lead.stage = stage.id;
      lead.stage_name = stage.name;
      lead.last_activity_date = new Date().toISOString();
    }
    return simulateLatency({ ok: true, lead });
  },
};
